import React from 'react';

const SummerMethodology = () => {
  const methods = [
    {
      icon: "🔬",
      title: "Scientific Curriculum",
      desc: "A 40-day precision-mapped syllabus designed to ensure mastery without academic stress."
    },
    {
      icon: "👨‍🏫",
      title: "Expert Mentorship",
      desc: "Training led by senior faculty members with a proven track record in IIT-JEE and NEET coaching."
    },
    {
      icon: "💡",
      title: "Concept Visualization",
      desc: "Moving beyond rote learning with visual aids that help students grasp complex MPC concepts easily."
    },
    {
      icon: "📊",
      title: "Weekly Assessments",
      desc: "Regular tracking of student progress with detailed feedback shared with parents every week."
    }
  ];

  return (
    <section className="methodology-section">
      <div className="container">
        <div className="method-header">
          <h2 className="section-heading">The Narayana Edge</h2>
          <p className="section-intro">How we transform 2,000+ students every summer through a decade of refined methodology.</p>
        </div>

        <div className="method-grid">
          {methods.map((item, index) => (
            <div key={index} className="method-card">
              <div className="method-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SummerMethodology;